import { createFeatureSelector, createSelector } from "@ngrx/store";
import { createFeatureReducerFactory } from "@ngrx/store/src/utils";
import { ValuationProcessConsiderationCriterionState } from "../_reducers/valuation-consideration-criterion.reducer";

export const selectValuationProcessConsiderationCriterionState = createFeatureSelector<ValuationProcessConsiderationCriterionState>('valuation-process-consideration-criterions')
export const selectValuationProcessConsiderationCriterion = createSelector(
    selectValuationProcessConsiderationCriterionState,
    state => state.item
)